import { registerBlockType } from '@wordpress/blocks';
import { people as icon } from '@wordpress/icons';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';
import deprecated from './deprecated';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  deprecated,
  icon: {
    foreground: '#0061FE',
    src: icon,
  },
});
